import { Component } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../_models/ITranslations";
import { TranslationService } from "../../_services/translation.service";
import { DataService } from "../../_services/data.service";
import { Router } from "@angular/router";
import { AlertService } from "../../_services/alert.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DomSanitizer } from "@angular/platform-browser";
import { SessionManagerService } from "../../_services/SessionManager/session-manager.service";
import { LocalStorageManagerService } from "../../_services/localStoageManager.service";
import { LoggerService } from "../../modules/logger/logger.service";

@Component({
  selector: "mock-test-component",
  template: ` <div class="relative"></div> `,
  styleUrls: ["../development.component.scss"],
})
export class MockTestComponent {
  public searchQuery: any;

  constructor(
    private router: Router,
    public dataService: DataService,
    private alertService: AlertService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private sessionManger: SessionManagerService,
    private localStorageManager: LocalStorageManagerService,
    private logger: LoggerService
  ) {}

  public async callSearchEvents() {}
}



// WEBPACK FOOTER //
// ./src/app/development/example/mock-test.component.ts